import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen p-8 bg-white" }
const _hoisted_2 = { class: "flex flex-col gap-3 max-w-2xl" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-3" }

import {
  mdiFileDocumentOutline,
  mdiEmailCheckOutline,
  mdiShieldLockOutline,
  mdiUpload
} from '@mdi/js'

import SelectCard from '@/components/designSystem/Cards/SelectCard.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SelectCard, {
          icon: _unref(mdiFileDocumentOutline),
          title: "Qualificação Documental",
          description: "Análise de documentação para alocação e faturamento",
          layout: "vertical",
          "data-testid": "qualification-doc-card"
        }, null, 8, ["icon"]),
        _createVNode(SelectCard, {
          icon: _unref(mdiEmailCheckOutline),
          title: "Qualificação para Repasse",
          description: "Análise de conformidade para pagamento",
          layout: "vertical",
          "data-testid": "qualification-transfer-card"
        }, null, 8, ["icon"])
      ]),
      _createVNode(SelectCard, {
        icon: _unref(mdiShieldLockOutline),
        title: "Política de Restrição",
        description: "Análise de documentação para alocação e faturamento",
        "data-testid": "restriction-policy-card"
      }, null, 8, ["icon"]),
      _createVNode(SelectCard, {
        icon: _unref(mdiUpload),
        title: "Importar validações",
        description: "Criar política a partir de arquivo externo",
        "data-testid": "import-validations-card"
      }, null, 8, ["icon"])
    ])
  ]))
}
}

})